export function SkeletonFilters() {
  return (
    <section className="animate-pulse">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {/* Búsqueda */}
        <div>
          <div className="h-4 w-32 bg-gray-200 rounded mb-2"></div>
          <div className="h-12 bg-gray-200 rounded-2xl"></div>
        </div>

        {/* Asesor */}
        <div>
          <div className="h-4 w-20 bg-gray-200 rounded mb-2"></div>
          <div className="h-12 bg-gray-200 rounded-2xl"></div>
        </div>

        {/* Checkbox */}
        <div>
          <div className="h-4 w-36 bg-gray-200 rounded mb-2"></div>
          <div className="h-12 bg-gray-200 rounded-2xl"></div>
        </div>

        {/* Botones */}
        <div className="md:col-span-3">
          <div className="h-4 w-20 bg-gray-200 rounded mb-2 invisible"></div>
          <div className="flex gap-3">
            <div className="flex-1 h-12 bg-gray-200 rounded-full"></div>
            <div className="flex-1 h-12 bg-gray-200 rounded-full"></div>
          </div>
        </div>
      </div>
    </section>
  );
}

/**
 * Skeleton para la tabla de préstamos
 */
export function SkeletonLoansTable() {
  return (
    <div className="overflow-x-auto">
      <table className="min-w-full text-sm">
          <thead>
            <tr className="text-[11px] font-semibold uppercase tracking-[0.2em] text-gray-500 bg-gray-50 border-b border-gray-200">
              <th className="py-3 px-3 text-center">#</th>
              <th className="py-3 px-3 text-left">PRÉSTAMO</th>
              <th className="py-3 px-3 text-left">CLIENTE</th>
              <th className="py-3 px-3 text-right">MONTO</th>
              <th className="py-3 px-3 text-center">TASA %</th>
              <th className="py-3 px-3 text-center">CUOTAS PAGADAS</th>
              <th className="py-3 px-3 text-center">CUOTAS PENDIENTES</th>
              <th className="py-3 px-3 text-center">FECHA VENC.</th>
              <th className="py-3 px-3 text-left">TELÉFONO</th>
              <th className="py-3 px-3 text-left">DIRECCIÓN</th>
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: 8 }).map((_, index) => (
              <tr key={index} className="border-b border-gray-200 animate-pulse">
                <td className="py-3 px-3">
                  <div className="h-4 w-8 bg-gray-200 rounded mx-auto"></div>
                </td>
                <td className="py-3 px-3">
                  <div className="h-4 w-16 bg-gray-200 rounded"></div>
                </td>
                <td className="py-3 px-3">
                  <div className="space-y-2">
                    <div className="h-4 w-32 bg-gray-200 rounded"></div>
                  </div>
                </td>
                <td className="py-3 px-3">
                  <div className="h-4 w-24 bg-gray-200 rounded ml-auto"></div>
                </td>
                <td className="py-3 px-3">
                  <div className="h-6 w-16 bg-gray-200 rounded-full mx-auto"></div>
                </td>
                <td className="py-3 px-3">
                  <div className="h-6 w-12 bg-gray-200 rounded-full mx-auto"></div>
                </td>
                <td className="py-3 px-3">
                  <div className="h-6 w-12 bg-gray-200 rounded-full mx-auto"></div>
                </td>
                <td className="py-3 px-3">
                  <div className="h-4 w-24 bg-gray-200 rounded"></div>
                </td>
                <td className="py-3 px-3">
                  <div className="h-4 w-40 bg-gray-200 rounded"></div>
                </td>
                <td className="py-3 px-3">
                  <div className="h-4 w-48 bg-gray-200 rounded"></div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
    </div>
  );
}

export function SkeletonKPICards() {
  return (
    <section className="mb-6 grid grid-cols-1 sm:grid-cols-2 gap-4">
      {Array.from({ length: 2 }).map((_, idx) => (
        <div
          key={idx}
          className="bg-white shadow-sm rounded-2xl p-6 border border-gray-100 animate-pulse"
        >
          <div className="flex items-center justify-between">
            <div className="flex-1 space-y-2">
              <div className="h-3 w-28 bg-gray-200 rounded"></div>
              <div className="h-8 w-16 bg-gray-200 rounded"></div>
              <div className="h-3 w-20 bg-gray-100 rounded"></div>
            </div>
            <div className="ml-4 h-12 w-12 bg-gray-100 rounded-xl"></div>
          </div>
        </div>
      ))}
    </section>
  );
}

/**
 * Estado vacío cuando no hay resultados
 */
export function EmptyState({ title, description, actionButton }) {
  return (
    <div className="bg-white rounded-xl shadow-lg p-12 text-center">
      <div className="mx-auto w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mb-4">
        <svg
          className="w-12 h-12 text-gray-400"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
          />
        </svg>
      </div>
      <h3 className="text-xl font-semibold text-gray-900 mb-2">{title}</h3>
      <p className="text-gray-600 mb-6 max-w-md mx-auto">{description}</p>
      {actionButton}
    </div>
  );
}

/**
 * Estado de error con opción de reintentar
 */
export function ErrorState({ title, message, onRetry }) {
  return (
    <div className="bg-white rounded-xl shadow-lg p-12 text-center max-w-md">
      <div className="mx-auto w-24 h-24 bg-red-100 rounded-full flex items-center justify-center mb-4">
        <svg
          className="w-12 h-12 text-red-600"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
          />
        </svg>
      </div>
      <h3 className="text-xl font-semibold text-gray-900 mb-2">{title}</h3>
      <p className="text-gray-600 mb-6">{message}</p>
      {onRetry && (
        <button
          onClick={onRetry}
          className="bg-red-600 hover:bg-red-700 text-white px-6 py-3 rounded-lg font-medium transition transform hover:scale-105"
        >
          Reintentar
        </button>
      )}
    </div>
  );
}

/**
 * Banner informativo skeleton
 */
export function SkeletonInfoBanner() {
  return (
    <div className="mb-6 bg-red-50 border border-red-200 rounded-lg px-6 py-4 animate-pulse">
      <div className="flex items-center justify-between">
        <div className="flex gap-6">
          <div className="h-4 w-40 bg-red-200 rounded"></div>
          <div className="h-4 w-32 bg-red-200 rounded"></div>
        </div>
        <div className="h-4 w-48 bg-red-200 rounded"></div>
      </div>
    </div>
  );
}

/**
 * Skeleton para paginación
 */
export function SkeletonPagination() {
  return (
    <div className="mt-6 flex items-center justify-between bg-white px-6 py-4 rounded-lg shadow animate-pulse">
      <div className="h-4 w-48 bg-gray-200 rounded"></div>
      <div className="flex gap-2">
        <div className="h-10 w-24 bg-gray-200 rounded-lg"></div>
        <div className="flex gap-2">
          {Array.from({ length: 5 }).map((_, i) => (
            <div key={i} className="h-10 w-10 bg-gray-200 rounded-lg"></div>
          ))}
        </div>
        <div className="h-10 w-24 bg-gray-200 rounded-lg"></div>
      </div>
    </div>
  );
}
